import { PrintOptionsVisibility } from '../types/print-options-visibility.type';

export const PRINT_OPTIONS_GERMAN_VISIBILITY: PrintOptionsVisibility = {
    consistencyCheck: {
        showDetails: false,
        isExpanded: true,
    },
    styleOptions: {
        textColor: true,
        titleColor: true,
        backgroundColor: true,
    },
    displayOptions: {
        hasCompanyInfosToggle: false,
        hasAccountsToggle: false,
        hasCoverSheetToggle: true,
        hasCompanyLogoToggle: true,
        hasUIDonCoverToggle: true,
        hasTableOfContentsToggle: true,
        hasDisableBalanceSheetPageBreakToggle: false,
        hasHideDecimalPlacesToggle: true,
        hasHideEmptyLinesToggle: true,
        hasHidePreviousYearToggle: true,
        hasFliTotalToggle: false,
        hasGroupHeadersToggle: false,
        hasGroupTotalsToggle: false,
        hasFcpToggle: true,
        hasAopToggle: false,
        hasCfsToggle: false,
        hasNotesToggle: false,
        hasComplementaryReportsToggle: false,
        hasEmsToggle: false,
        hasFasToggle: false,
        hasPrintInGrayscaleToggle: false,
        hasCustomPageNumbersToggle: false,
        hasReClassInSumsToggle: false,
        hasAdjustmentInSumsToggle: false,
        hasRatiosToggle: true,
        hasShareholderInformationToggle: false,
        hasAccountNumbersToggle: false,
        hasAccountProofForBalanceToggle: false,
        hasAccountProofForIncomeToggle: false,
        hasExperimentalOptions: false,
        hasAopHideDecimalPlacesValuesToggle: false,
        hasAopHideDecimalPlacesRatiosToggle: false,
        hasAopHideEmptyLinesToggle: false,
        hasNotesHideDecimalPlacesValuesToggle: false,
        hasNotesHideDecimalPlacesRatiosToggle: false,
        hasNotesHideEmptyLinesToggle: false,
        hasFinStatementHideDecimalPlacesValuesToggle: false,
        hasFinStatementHideDecimalPlacesRatiosToggle: true,
        hasFinStatementHideEmptyLinesToggle: false,
        hasFinStatementRoundToThousandsToggle: false,
        hasNotesRoundToThousandsToggle: false,
        hasAopRoundToThousandsToggle: false,
        hasPrintExportButtons: false,
        hasNonBreakingHyphenToggle: true,
        hasApplyGroupingMaskingToggle: true,
        hasRepeatAppendixTitleToggle: false,
    },
    signatureOptions: {
        hasSignature: true,
        isCollectiveSignature: true,
        placeSignatureAfterAop: false,
    },
};
